const styles = {
    saveButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '200px',
        height: '48px',
        textTransform: 'none',
        mt: 5,
        ml: 3,
    },
    addressField: {
        marginTop: '24px',
    },
    addressField2: {
        marginTop: '21px',
    },
};
export default styles;
